enum Role {
    Developer = 0,
    Agent = 1,
    Administrator = 2,
    TeamLead = 3,
}

export default Role;
